import { useTranslation } from 'react-i18next';
import { useAuth } from '../../../context/AuthContext';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { generateTranslateMuiTable } from '../../../utils/Function/commonFunction';
import DeleteIcon16pxSvg from '../../../assets/images/icons/DeleteIcon16pxSvg';
import DefaultTooltip from '../../../components/DefaultTooltip';
import QuestionIcon16pxSvg from '../../../assets/images/icons/QuestionIcon16pxSvg';
import { CustomAdvancedMenuList, CustomSecondaryButton, NormalSwitch, StyledDataGrid } from '../../../components/StyledComponents';
import RefreshCircleIcon20pxSvgV2 from '../../../assets/images/icons/RefreshCircleIcon20pxSvgV2';
import NoRowOverlay from '../../../assets/images/icons/NoRowOverlay';
import CustomColumnsPanel from '../../../components/CustomColumnsPanel';
import { ControlpanelPrimaryButton } from '../../../components/StyledButton';
import AddBoxIcon from '@mui/icons-material/AddBox';
import { toast } from 'react-toastify';
import Cookies from "js-cookie";
import { getListEntitieById, resetSetting, updateSetting } from '../../../axios/Setting/SettingUrlApi';
import EditNew20pxSvg from '../../../assets/images/icons/EditNew20pxSvg';
import { getListDepartment } from '../../../axios/Department/DepartmentApi';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import RemoveDepartmentDialog from './RemoveDepartmentDialog';
import AddDepartmentDialog from './AddDepartmentDialog';
import EditDepartmentDialog from './EditDepartmentDialog';
import ConfirmResetAllDialog from './ConfirmResetAllDialog';
import CustomGridToolbarQuickFilterNew2 from '../CustomGridToolbarQuickFilterNew2';
import {
    ClickAwayListener,
    Grow,
    Link,
    MenuItem,
    Paper,
    Popper,
} from "@mui/material";
import ExportIcon20pxSvg from '../../../assets/images/icons/ExportIcon20pxSvg';
import ImportIcon20pxSvg from '../../../assets/images/icons/ImportIcon20pxSvg';
import AddIcon from '@mui/icons-material/Add';
import CustomSplitButton from '../../../components/CustomSplitButton';
import AddDesignationDialog from './AddDesignationDialog';
import { getListDesignation } from '../../../axios/Designation/DesignationApi';
import EditDesignationDialog from './EditDesignationDialog';
import RemoveDesignationDialog from './RemoveDesignationDialog';
import ImportIcon16pxSvg from '../../../assets/images/icons/ImportIcon16pxSvg';
dayjs.extend(utc);
dayjs.extend(timezone)

const OrganizationTab = ({ departmentTabId, refreshData, handleRefresh, tabId }) => {
    const { t } = useTranslation();
    const { refreshProfileSetting } = useAuth();
    const [settingsData, setSettingsData] = useState([]);
    const [gridLoading, setGridLoading] = useState(false);
    const { profile, dateTimeFormat } = useAuth();
    const tableTranslated = useMemo(() => generateTranslateMuiTable(t), [t]);
    const [removeDepartmentOpen, setRemoveDepartmentOpen] = useState(false);
    const [addDepartmentOpen, setAddDepartmentOpen] = useState(false);
    const [rowSelect, setRowSelect] = useState([]);
    const [department, setDepartments] = useState([])
    const [editDepartmentOpen, setEditDepartmentOpen] = useState(false)
    const [departmentSetting, setDepartmentSetting] = useState(false)
    const [confirmResetAllOpen, setConfirmResetAllOpen] = useState(false);
    const anchorRefDepartmentAdvanced = useRef(null);
    const anchorRefDesignationAdvanced = useRef(null);
    const [openAdvancedMenu, setOpenAdvancedMenu] = useState(null);
    const [addDesignationOpen, setAddDesignationOpen] = useState(false);
    const [designation, setDesignation] = useState([])
    const [editDesignationOpen, setEditDesignationOpen] = useState(false)
    const [removeDesignationOpen, setRemoveDesignationOpen] = useState(false)

    const [formData, setFormData] = useState({
        department: true,
    });

    const handleToggleAdvanced = (menuType) => {
        setOpenAdvancedMenu((prev) => (prev === menuType ? null : menuType));
    };

    const handleCloseAdvanced = (event) => {
        if (
            anchorRefDepartmentAdvanced.current?.contains(event.target) ||
            anchorRefDesignationAdvanced.current?.contains(event.target)
        ) {
            return;
        }
        setOpenAdvancedMenu(null);
    };

    const advancedMenuAnchorEl =
        openAdvancedMenu === "department"
            ? anchorRefDepartmentAdvanced.current
            : openAdvancedMenu === "designation"
                ? anchorRefDesignationAdvanced.current
                : null;

    const handleCloseRemoveDepartment = () => {
        setRemoveDepartmentOpen(false);
    };

    const handleCloseRemoveDesignation = () => {
        setRemoveDesignationOpen(false);
    };

    const handleCloseAddDepartment = () => {
        setAddDepartmentOpen(false);
    };

    const handleCloseEditDepartment = () => {
        setEditDepartmentOpen(false);
    };

    const handleCloseEditDesignation = () => {
        setEditDesignationOpen(false);
    };

    const handleOpenAddDepartment = () => {
        setAddDepartmentOpen(true)
    };

    const handleOpenAddDesignation = () => {
        setAddDesignationOpen(true)
    }
    const handleCloseAddDesignation = () => {
        setAddDesignationOpen(false)
    }


    useEffect(() => {
        const fetchDataDepartment = async () => {
            try {
                const response = await getListDepartment({ langId: localStorage.getItem("i18nextLngId") });
                setDepartments(response.data.data)
            } catch (error) {
                if (error.response) {
                    if (error.response.status !== 401) {
                        toast.error(t(error?.response.data.message));
                    }
                } else {
                    toast.error(t('common.network-timeout'));
                }
            }
        };

        fetchDataDepartment();
    }, [refreshData]);

    useEffect(() => {
        const fetchDataDepartment = async () => {
            try {
                const response = await getListDesignation({ langId: localStorage.getItem("i18nextLngId") });
                setDesignation(response.data.data)
            } catch (error) {
                if (error.response) {
                    if (error.response.status !== 401) {
                        toast.error(t(error?.response.data.message));
                    }
                } else {
                    toast.error(t('common.network-timeout'));
                }
            }
        };

        fetchDataDepartment();
    }, [refreshData]);

    useEffect(() => {
        const fetchData = async () => {
            const payload = {
                entityId: departmentTabId,
                langId: localStorage.getItem("i18nextLngId")
            }
            try {
                const { data } = await getListEntitieById(payload);
                setDepartmentSetting(data.data[0])
                setSettingsData(data.data);
                setFormData(prev => ({
                    ...prev,
                    department: data.data[0]?.value === '0' ? false : true,
                }));

            } catch (error) {
                if (error.response) {
                    if (error.response.status !== 401) {
                        toast.error(t(error?.response.data));
                    }
                } else {
                    toast.error(t('common.network-timeout'));
                }
            }
        };
        if (tabId) {
            fetchData();
        }
    }, [tabId, refreshData]);

    const handleResetSetting = async (entityAttrTypeId) => {
        const payload = {
            entityId: departmentTabId,
            entityAttributeTypeId: entityAttrTypeId,
            langId: localStorage.getItem("i18nextLngId"),
        };
        try {
            const response = await resetSetting(payload);
            if (response?.data?.responseCode === 0) {
                toast.success(t("common.reset-setting-successfully"));
                handleRefresh();
                refreshProfileSetting();
            } else {
                toast.error(response?.data?.message);
            }
        } catch (error) {
            if (error.response) {
                if (error.response.status !== 401) {
                    toast.error(t(error?.response.data));
                }
            } else {
                toast.error(t('common.network-timeout'));
            }
        }
    };

    const handleInputChange = (e) => {
        const { name, checked, type } = e.target;
        const value = type === 'checkbox' ? checked : e.target.value;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
        handleSaveSettings(value)
    };

    const convertFormat = (format) => {
        return format
            .replace(/dd/g, "DD")
            .replace(/MM/g, "MM")
            .replace(/yyyy/g, "YYYY");
    };

    const columnData = [
        { field: 'departmentName', headerName: t('common.name'), hideable: true, flex: 1, },
        { field: 'departmentPrefix', headerName: t('common.prefix'), width: 90, hideable: true, },
        {
            field: 'createdAt', headerName: t('common.created-time'), flex: 1, hideable: true, valueFormatter: (value) => {
                if (!value) return "-";

                const format = convertFormat(dateTimeFormat);

                return dayjs
                    .utc(value, "YYYY-MM-DD HH:mm:ss")
                    .local()
                    .format(format);
            }
        },
        { field: 'createdBy', headerName: t('common.created-by'), flex: 1, hideable: true, },
        {
            field: 'option',
            headerName: t('common.options'),
            flex: 1,
            hideable: true,
            sortable: false,
            filterable: false,
            renderCell: (params) => (
                <div
                    className="flex gap-2 items-center justify-start h-full"
                    onClick={(e) => e.stopPropagation()}
                >
                    {/* EDIT */}
                    <button
                        className="p-2 rounded-lg hover:bg-gray-100 transition cursor-pointer"
                        onClick={() => handleEdit(params.row)}
                    >
                        <EditNew20pxSvg className="w-5 h-5" />
                    </button>

                    {/* DELETE */}
                    <button
                        className="p-2 rounded-lg hover:bg-red-100 transition cursor-pointer"
                        onClick={() => handleDelete(params.row)}
                    >
                        <DeleteIcon16pxSvg className="w-5 h-5" color="#D00D00" />
                    </button>
                </div>
            ),
        }

    ];

    const columnDataDesignation = [
        { field: 'designationName', headerName: t('common.name'), hideable: true, flex: 1, },
        { field: 'remark', headerName: t('common.description'), flex: 1, hideable: true, },
        {
            field: 'option',
            headerName: t('common.options'),
            flex: 1,
            hideable: true,
            sortable: false,
            filterable: false,
            renderCell: (params) => (
                <div
                    className="flex gap-2 items-center justify-start h-full"
                    onClick={(e) => e.stopPropagation()}
                >
                    {/* EDIT */}
                    <button
                        className="p-2 rounded-lg hover:bg-gray-100 transition cursor-pointer"
                        onClick={() => handleEditDesignation(params.row)}
                    >
                        <EditNew20pxSvg className="w-5 h-5" />
                    </button>

                    {/* DELETE */}
                    <button
                        className="p-2 rounded-lg hover:bg-red-100 transition cursor-pointer"
                        onClick={() => handleDeleteDesignation(params.row)}
                    >
                        <DeleteIcon16pxSvg className="w-5 h-5" color="#D00D00" />
                    </button>
                </div>
            ),
        }

    ];

    const handleEdit = (row) => {
        setRowSelect(row)
        setEditDepartmentOpen(true)
    };

    const handleEditDesignation = (row) => {
        setRowSelect(row)
        setEditDesignationOpen(true)
    };

    const handleDelete = async (row) => {
        setRowSelect(row)
        setRemoveDepartmentOpen(true)
    };

    const handleDeleteDesignation = async (row) => {
        setRowSelect(row)
        setRemoveDesignationOpen(true)
    };

    const [columnVisibilityModel, setColumnVisibilityModel] = useState({
        departmentName: true,
        departmentPrefix: true,
        createdAt: true,
        createdBy: true,
        option: true,

    });
    const emailUser = profile?.email;
    const handleColumnVisibilityChange = (newModel) => {
        setColumnVisibilityModel(newModel);
        Cookies.set(`DepartmentTab_${emailUser}`, JSON.stringify(newModel), {
            expires: 90,
            path: "/",
        });
    };

    useEffect(() => {
        const saved = Cookies.get(`DepartmentTab_${emailUser}`);
        if (saved) {
            setColumnVisibilityModel(JSON.parse(saved));
        }
    }, []);

    const handleSaveSettings = async (valueChange) => {
        const payload = {
            entityId: departmentTabId,
            entityAttributeTypeId: departmentSetting.entityAttrTypeId,
            value: valueChange ? "1" : "0",
            langId: localStorage.getItem("i18nextLngId")
        }
        try {
            const response = await updateSetting(payload);
            if (response?.data?.responseCode === 0) {
                toast.success(t('common.update-setting-successfully'));
                handleRefresh();
            } else {
                toast.error(response?.data?.message);
            }
        } catch (error) {
            if (error.response) {
                if (error.response.status !== 401) {
                    toast.error(t(error?.response.data));
                }
            } else {
                toast.error(t('common.network-timeout'));
            }
        }
    };

    const handleResetAll = async () => {
        setConfirmResetAllOpen(false);
        const promises = settingsData.map(async (item) => {
            const payload = {
                entityId: tabId,
                entityAttributeTypeId: item.entityAttrTypeId,
                langId: localStorage.getItem("i18nextLngId"),
            };
            return resetSetting(payload);
        });

        try {
            const responses = await Promise.all(promises);
            const allSuccessful = responses.every((r) => r?.data?.responseCode === 0);
            if (allSuccessful) {
                toast.success(t("common.reset-setting-successfully"));
                handleRefresh();
                refreshProfileSetting();
            } else {
                toast.error("Some settings failed to reset");
            }
        } catch (error) {
            toast.error("Failed to reset all settings");
        }
    };

    const handleCloseConfirmResetAll = () => {
        setConfirmResetAllOpen(false);
    };

    const handleOpenConfirmResetAll = () => {
        setConfirmResetAllOpen(true);
    };

    const handleQuickFilterChange = (searchText) => {
        // const lowerSearch = searchText.toLowerCase();
        // const filtered = rowData.filter((row) =>
        //     Object.values(row).some((val) =>
        //         String(val).toLowerCase().includes(lowerSearch)
        //     )
        // );
        // setRowData(filtered);
    };

    const templateToolbar = useCallback(
        () => (
            <div className="flex items-center gap-3 mb-2 h-10">
                {/* SEARCH */}
                <div className="flex-1 min-w-0 h-10 flex items-center">
                    <CustomGridToolbarQuickFilterNew2
                        onSearchChange={handleQuickFilterChange}
                    />
                </div>

                <div className="shrink-0 h-10 flex items-center">
                    <CustomSplitButton
                        label={t("button.add")}
                        startIcon={<AddIcon className="!text-[16px]" />}
                        onMainClick={handleOpenAddDepartment}
                        onDropdownClick={() => handleToggleAdvanced("department")}
                        ref={anchorRefDepartmentAdvanced}
                    />
                </div>
            </div>
        ),
        [t]
    );

    const templateToolbarDesignation = useCallback(
        () => (
            <div className="flex items-center gap-3 mb-2 h-10">
                {/* SEARCH */}
                <div className="flex-1 min-w-0 h-10 flex items-center">
                    <CustomGridToolbarQuickFilterNew2
                        onSearchChange={handleQuickFilterChange}
                    />
                </div>

                <div className="shrink-0 h-10 flex items-center">
                    <CustomSplitButton
                        label={t("button.add")}
                        startIcon={<AddIcon className="!text-[16px]" />}
                        onMainClick={handleOpenAddDesignation}
                        onDropdownClick={() => handleToggleAdvanced("designation")}
                        ref={anchorRefDesignationAdvanced}
                    />
                </div>
            </div>
        ),
        [t]
    );

    const hasRowDepartment = department.length > 0;
    const hasRowDesignation = designation.length > 0;

    const gridHeight = hasRowDepartment ? "49vh" : "49vh";
    const gridHeightDesignation = hasRowDesignation ? "59vh" : "59vh";

    return (
        <>
            <div className="
                grid
                2xl:grid-cols-2
                grid-cols-1
                gap-0
            ">
                {/* LEFT */}
                <div className="2xl:pr-2">
                    <div className='bg-[#F9FAFB] p-4 rounded-[16px] space-y-2' data-tour="setting-department">
                        <h2 className='font-semibold'>{t('common.departments')}</h2>

                        <div className="grid grid-cols-12 items-center py-5">
                            {/* LEFT */}
                            <div className="col-span-6 flex items-center gap-2">
                                <p className="text-sm">{t("common.departments-des")}</p>
                                <DefaultTooltip
                                    title={t("common.prefix")}
                                    readMore={false}
                                    content={
                                        <div className="flex flex-col gap-3">
                                            <p>{t("common.tooltip-department")}.</p>
                                        </div>
                                    }
                                > <div>
                                        <QuestionIcon16pxSvg className="fill-[#BDBDBD]" />
                                    </div></DefaultTooltip>
                            </div>

                            {/* RIGHT */}
                            <div className="col-span-6 flex justify-end">
                                <div className='flex gap-2 items-center'>
                                    <NormalSwitch
                                        name="department"
                                        checked={formData.department}
                                        onChange={handleInputChange}
                                    />
                                    <CustomSecondaryButton
                                        onClick={() =>
                                            handleResetSetting(departmentSetting?.entityAttrTypeId)
                                        }
                                        disabled={!departmentSetting?.entityAttrTypeId}
                                    >
                                        <RefreshCircleIcon20pxSvgV2 />
                                    </CustomSecondaryButton>
                                </div>
                            </div>
                        </div>

                        {formData.department &&
                            <>
                                <StyledDataGrid
                                    sx={{
                                        height: gridHeight,
                                        backgroundColor: "#FFFFFF",
                                        "& .MuiDataGrid-main": {
                                            backgroundColor: "#FFFFFF",
                                        },
                                        "& .MuiDataGrid-virtualScroller": {
                                            backgroundColor: "#FFFFFF",
                                        },
                                        "& .MuiDataGrid-footerContainer": {
                                            backgroundColor: "#FFFFFF",
                                        },
                                    }}
                                    rows={department}
                                    rowCount={department.length}
                                    columns={columnData}
                                    loading={gridLoading}
                                    // getRowId={(r) => r.userId}

                                    slots={{
                                        toolbar: templateToolbar,
                                        noRowsOverlay: NoRowOverlay,
                                        columnsPanel: CustomColumnsPanel,
                                    }}
                                    hideFooter
                                    localeText={tableTranslated}
                                    columnVisibilityModel={columnVisibilityModel}
                                    onColumnVisibilityModelChange={handleColumnVisibilityChange}
                                />
                            </>
                        }
                    </div>
                </div>

                {/* RIGHT */}
                <div className="2xl:pl-2">
                    <div className='bg-[#F9FAFB] p-4 rounded-[16px] space-y-2' data-tour="setting-designation">
                        <h2 className='font-semibold'>{t('common.designation')}</h2>

                        <StyledDataGrid
                            sx={{
                                height: gridHeightDesignation,
                                backgroundColor: "#FFFFFF",
                                "& .MuiDataGrid-main": {
                                    backgroundColor: "#FFFFFF",
                                },
                                "& .MuiDataGrid-virtualScroller": {
                                    backgroundColor: "#FFFFFF",
                                },
                                "& .MuiDataGrid-footerContainer": {
                                    backgroundColor: "#FFFFFF",
                                },
                            }}
                            rows={designation}
                            rowCount={designation.length}
                            columns={columnDataDesignation}
                            loading={gridLoading}
                            // getRowId={(r) => r.userId}

                            slots={{
                                toolbar: templateToolbarDesignation,
                                noRowsOverlay: NoRowOverlay,
                                columnsPanel: CustomColumnsPanel,
                            }}
                            hideFooter
                            localeText={tableTranslated}
                        // columnVisibilityModel={columnVisibilityModel}
                        // onColumnVisibilityModelChange={handleColumnVisibilityChange}
                        />
                    </div>
                </div>
            </div>

            {removeDepartmentOpen && <RemoveDepartmentDialog row={rowSelect} onClose={handleCloseRemoveDepartment} onRefresh={handleRefresh} refreshData={refreshData} />}
            {removeDesignationOpen && <RemoveDesignationDialog row={rowSelect} onClose={handleCloseRemoveDesignation} onRefresh={handleRefresh} refreshData={refreshData} />}
            {addDepartmentOpen && <AddDepartmentDialog onClose={handleCloseAddDepartment} onRefresh={handleRefresh} refreshData={refreshData} />}
            {addDesignationOpen && <AddDesignationDialog onClose={handleCloseAddDesignation} onRefresh={handleRefresh} refreshData={refreshData} />}
            {editDepartmentOpen && <EditDepartmentDialog row={rowSelect} onClose={handleCloseEditDepartment} onRefresh={handleRefresh} refreshData={refreshData} />}
            {editDesignationOpen && <EditDesignationDialog row={rowSelect} onClose={handleCloseEditDesignation} onRefresh={handleRefresh} refreshData={refreshData} />}
            {confirmResetAllOpen && (
                <ConfirmResetAllDialog
                    onClose={handleCloseConfirmResetAll}
                    onConfirm={handleResetAll}
                />
            )}

            <Popper
                open={Boolean(openAdvancedMenu)}
                anchorEl={advancedMenuAnchorEl}
                placement="bottom-start"
                transition
                disablePortal
                className="z-10"
            >
                {({ TransitionProps, placement }) => (
                    <Grow
                        {...TransitionProps}
                        style={{
                            transformOrigin:
                                placement === "bottom" ? "left top" : "left bottom",
                        }}
                    >
                        <Paper style={{ borderRadius: "8px", }}>
                            <ClickAwayListener onClickAway={handleCloseAdvanced}>
                                <CustomAdvancedMenuList
                                    id="advanced-menu"
                                    aria-labelledby="advanced-button"
                                >
                                    <MenuItem
                                        style={{
                                            borderBottom: "1px solid #E5E7EB",
                                            opacity: "0.5",
                                            pointerEvents: "none",
                                        }}
                                    >
                                        <Link>
                                            <ImportIcon16pxSvg />
                                            <p>{t("button.import-data")}</p>
                                        </Link>
                                    </MenuItem>
                                    <MenuItem
                                        style={{
                                            borderBottom: "1px solid #E5E7EB",
                                            opacity: "0.5",
                                            pointerEvents: "none",
                                        }}
                                    >
                                        <Link>
                                            <ExportIcon20pxSvg />
                                            <p>{t("button.export-data")}</p>
                                        </Link>
                                    </MenuItem>
                                    <MenuItem
                                        style={{
                                            borderBottom: "1px solid #E5E7EB",
                                            opacity: "0.5",
                                            pointerEvents: "none",
                                        }}
                                    >
                                        <Link>
                                            <DeleteIcon16pxSvg className="w-5 h-5" color="#D00D00" />
                                            <p>{t("common.delete-all")}</p>
                                        </Link>
                                    </MenuItem>

                                </CustomAdvancedMenuList>
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                )}
            </Popper>
        </>
    )
}

export default OrganizationTab